import {Component} from '@angular/core';

@Component({
    selector: 'app-page-no-access',
    templateUrl: './page-no-access.component.html',
    styleUrls: ['./page-no-access.component.scss'],
    standalone: false
})
export class PageNoAccessComponent {

}
